import React, { Component } from 'react';
import JobItemSaved from './JobItemSaved';
import { Loader } from "../../../../common/elements";
import JobsMpu from '../../../../common/adverts/googleDFP/JobsMpu';

class JobsListSaved extends Component {
    render() {
        const { jobs, permissions, network, removeJobFromFavourites, addJobToFavourites } = this.props;

        if( !jobs ) {
            return <Loader/>;
        }
        
        return (
            <section className="jobs-list--saved">
                {
                    Object.keys( jobs ).map( ( job, index ) =>
                        jobs[ job ].id
                            ? <JobItemSaved key={ index } addJobToFavourites={ addJobToFavourites } removeJobFromFavourites={ removeJobFromFavourites } index={ index } job={ jobs[ job ] } permissions={ permissions } network={ network } />
                            : <JobsMpu key={ index } { ...jobs[ job ] }/>
                    )
                }
            </section>
        );
    };
}

export default JobsListSaved;


// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/JobsListSaved.js